<template>
  <v-row class="ma-0 pa-0 audience-bar-chart" justify="start">
    <v-col cols="12" class="ma-0 pa-0 audience-bar-chart__canvas">
      <v-chart class="chart" :option="graph_options" autoresize></v-chart>
    </v-col>
  </v-row>
</template>

<script>
import VChart, { THEME_KEY } from "vue-echarts";
import "echarts";
import { use } from "echarts/core";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { GridComponent, TitleComponent, TooltipComponent } from "echarts/components";
import cpalette from "@/configs/ChartColors/get_color_palette";

use([BarChart, CanvasRenderer, GridComponent, TitleComponent, TooltipComponent]);

export default {
  name: "AudienceBarChart",
  props: ["chart_title", "chart_data", "color_palette"],
  provide: {
    [THEME_KEY]: "light",
  },
  components: {
    VChart,
  },
  computed: {
    categories: function () {
      return (this.chart_data || []).map((row) => row[0]);
    },
    values: function () {
      return (this.chart_data || []).map((row) => Number(row[1]) || 0);
    },
    graph_options: function () {
      const colors = cpalette.get_color_palette(this.color_palette || "cool");

      return {
        title: {
          text: this.chart_title,
          left: "center",
          top: 0,
          textStyle: {
            fontFamily: "Poppins",
            fontSize: 14,
            fontWeight: 600,
          },
        },
        color: colors,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          textStyle: {
            fontFamily: "Poppins",
          },
          formatter: function (params) {
            const point = params && params[0] ? params[0] : {};
            return `${point.name}: ${Number(point.value || 0).toLocaleString()}`;
          },
        },
        grid: {
          left: 44,
          right: 16,
          top: 44,
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.categories,
          axisLabel: {
            fontFamily: "Poppins",
            fontSize: 10,
            interval: 0,
            rotate: 45,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          axisLabel: {
            fontFamily: "Poppins",
            fontSize: 11,
          },
          splitLine: {
            show: true,
          },
        },
        series: [
          {
            type: "bar",
            data: this.values,
            barMaxWidth: 28,
            itemStyle: {
              color: colors[0],
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.audience-bar-chart {
  height: 100%;
  width: 100%;
}

.audience-bar-chart__canvas {
  height: 100%;
}

.chart {
  height: 100%;
  width: 100%;
}
</style>
